import { BRAND_PERSONALITY_MIN_STEP_VALUE, BRAND_PERSONALITY_STEP_SIZE } from './constants';

/**
 * Converts -1,-.5,0,.5,1 to 1,2,3,4,5
 */

export const getBrandPersonalityStepValue = (stepValue = 0) =>
    (stepValue + Math.abs(BRAND_PERSONALITY_MIN_STEP_VALUE - BRAND_PERSONALITY_STEP_SIZE)) /
    BRAND_PERSONALITY_STEP_SIZE;

/**
 * Converts 1,2,3,4,5 to -1,-.5,0,.5,1
 */

export const getRevertedBrandPersonalityStepValue = (stepValue = 3) =>
    BRAND_PERSONALITY_STEP_SIZE * stepValue - Math.abs(BRAND_PERSONALITY_MIN_STEP_VALUE - BRAND_PERSONALITY_STEP_SIZE);
